module.exports = __webpack_public_path__ + "static/logoSpeedware-f52940005ab673ce906853fdb3a2c20e.jpg";